// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: aHl0lZDMsW2
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Checkbox from "../../Checkbox"; // plasmic-import: hFhNx9FR2Sv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicNewPlanInformation.module.css"; // plasmic-import: aHl0lZDMsW2/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicNewPlanInformation__VariantProps = new Array();

export const PlasmicNewPlanInformation__ArgProps = new Array();

const $$ = {};

function PlasmicNewPlanInformation__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "freeCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "premiumCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "growthCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "customCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__jJ4Qe)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hLd8
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__grfnF)}>
            <div className={classNames(projectcss.all, sty.freeBox__gZwyl)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___2R31I)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__xiY9E)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gtuKd)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__xRw4R)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__cksuw)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__lRxQu)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ksHf)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__htXy)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__cinjD)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__dw97
                )}
              >
                {"Account Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fuDeN
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__sJqlk
                )}
              >
                {"Plan Information"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yvooA
                )}
              >
                {"Confirm Identity"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div
                data-plasmic-name={"title12"}
                data-plasmic-override={overrides.title12}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title12
                )}
              >
                {"Select your plan type"}
              </div>
              <div
                data-plasmic-name={"title13"}
                data-plasmic-override={overrides.title13}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title13
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {
                      "Choose between a free plan with low transaction fees or a paid subscription with 0% transaction fees. You may switch your plan at any time and won't be charged until your account has been successfully approved for payments. \u00a0"
                    }
                  </React.Fragment>
                  {
                    <a
                      data-plasmic-name={"link"}
                      data-plasmic-override={overrides.link}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link
                      )}
                      href={`/new-page-6`}
                    >
                      {"Learn More"}
                    </a>
                  }

                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__icWtv)}>
                <Checkbox
                  data-plasmic-name={"freeCheck"}
                  data-plasmic-override={overrides.freeCheck}
                  className={classNames("__wab_instance", sty.freeCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "freeCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "freeCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {"Free Plan ($0/month) - No Transaction Limit"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__ffxW0)}>
                <Checkbox
                  data-plasmic-name={"premiumCheck"}
                  data-plasmic-override={overrides.premiumCheck}
                  className={classNames("__wab_instance", sty.premiumCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "premiumCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "premiumCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title10"}
                  data-plasmic-override={overrides.title10}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title10
                  )}
                >
                  {"Premium Plan ($39/month) - Process up to $15,000/month"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__xLjJ)}>
                <Checkbox
                  data-plasmic-name={"growthCheck"}
                  data-plasmic-override={overrides.growthCheck}
                  className={classNames("__wab_instance", sty.growthCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "growthCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "growthCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title11"}
                  data-plasmic-override={overrides.title11}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title11
                  )}
                >
                  {"Growth Plan ($89/month) - Process up to $35,000/month"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__uJ1O)}>
                <Checkbox
                  data-plasmic-name={"customCheck"}
                  data-plasmic-override={overrides.customCheck}
                  className={classNames("__wab_instance", sty.customCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "customCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "customCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title14"}
                  data-plasmic-override={overrides.title14}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title14
                  )}
                >
                  {"Custom Plan - Custom Processing Limit"}
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ color: "#FF0700" }}
                  >
                    {"Must select a plan before submitting your application"}
                  </span>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"submitButton"}
                data-plasmic-override={overrides.submitButton}
                className={classNames(projectcss.all, sty.submitButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zwazF
                  )}
                >
                  {"Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle5",
    "vertStack",
    "title12",
    "title13",
    "link",
    "freeCheck",
    "title8",
    "premiumCheck",
    "title10",
    "growthCheck",
    "title11",
    "customCheck",
    "title14",
    "errorText",
    "submitButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle5"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle5: ["circle5"],
  vertStack: [
    "vertStack",
    "title12",
    "title13",
    "link",
    "freeCheck",
    "title8",
    "premiumCheck",
    "title10",
    "growthCheck",
    "title11",
    "customCheck",
    "title14",
    "errorText",
    "submitButton"
  ],

  title12: ["title12"],
  title13: ["title13", "link"],
  link: ["link"],
  freeCheck: ["freeCheck"],
  title8: ["title8"],
  premiumCheck: ["premiumCheck"],
  title10: ["title10"],
  growthCheck: ["growthCheck"],
  title11: ["title11"],
  customCheck: ["customCheck"],
  title14: ["title14"],
  errorText: ["errorText"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewPlanInformation__ArgProps,
          internalVariantPropNames: PlasmicNewPlanInformation__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewPlanInformation__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewPlanInformation";
  } else {
    func.displayName = `PlasmicNewPlanInformation.${nodeName}`;
  }
  return func;
}

export const PlasmicNewPlanInformation = Object.assign(
  // Top-level PlasmicNewPlanInformation renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle5: makeNodeComponent("circle5"),
    vertStack: makeNodeComponent("vertStack"),
    title12: makeNodeComponent("title12"),
    title13: makeNodeComponent("title13"),
    link: makeNodeComponent("link"),
    freeCheck: makeNodeComponent("freeCheck"),
    title8: makeNodeComponent("title8"),
    premiumCheck: makeNodeComponent("premiumCheck"),
    title10: makeNodeComponent("title10"),
    growthCheck: makeNodeComponent("growthCheck"),
    title11: makeNodeComponent("title11"),
    customCheck: makeNodeComponent("customCheck"),
    title14: makeNodeComponent("title14"),
    errorText: makeNodeComponent("errorText"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicNewPlanInformation
    internalVariantProps: PlasmicNewPlanInformation__VariantProps,
    internalArgProps: PlasmicNewPlanInformation__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicNewPlanInformation;
/* prettier-ignore-end */
